import { render, staticRenderFns } from "./AwardsTile.vue?vue&type=template&id=3dace21b&scoped=true&"
import script from "./AwardsTile.vue?vue&type=script&lang=js&"
export * from "./AwardsTile.vue?vue&type=script&lang=js&"
import style0 from "./AwardsTile.vue?vue&type=style&index=0&id=3dace21b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dace21b",
  null
  
)

export default component.exports